<template>
    <div>
        <div class="m-auto mt-12">
            <div v-for="(step, i) in store.steps" :key="step.title">
              <ProgressStep :type="getType(step.id)"
                  :title="step.title" :description="step.description" :showBorder="i < store.steps.length - 1" :subItem="false" :smallBorder="(step.children && step.children.length > 0) ?? false" />
              <ProgressStep v-for="(subStep) in step.children" :key="subStep.title" :type="getType(subStep.id)"
                  :title="subStep.title" description="" :showBorder="true" :subItem="true" :smallBorder="true" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import ProgressStep from './ProgressStep.vue'
import { useRegistrationStore } from '../stores/registration.ts'

const store = useRegistrationStore()

function getType(step: number) {
    return store.typeForStep(step)
}
</script>
